import { Stack, Typography, useMediaQuery } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import PushPinIcon from "@mui/icons-material/PushPin";
import { useTheme } from "@mui/material/styles";
import { CardsData } from "./CardsData";
import { IsSelectable } from "./IsSelectable";
import { memo } from "react";

const IconOk = memo(function IconOk() {
  return <PushPinIcon fontSize="small" color="info" className="Mr1" />;
});
const IconNo = memo(function IconOk() {
  return <ErrorOutlineIcon fontSize="small" color="error" className="Mr1" />;
});

export const RigaSocio = memo(function RigaSocio(props: {
  option: CardsData;
  giorno?: Date;
  prenotazione?: boolean;
  certificatoObbligatorio?: boolean;
}) {
  const { option, giorno, certificatoObbligatorio } = props;
  let { prenotazione } = props;
  const theme = useTheme();
  const small = useMediaQuery(theme.breakpoints.down("md"));
  if (prenotazione === undefined) prenotazione = true;

  return (
    <>
      {!giorno || IsSelectable(option, giorno, certificatoObbligatorio ?? false) ? (
        <IconOk />
      ) : (
        <IconNo />
      )}
      <Stack direction={small ? "column" : "row"}>
        <div className={prenotazione ? "RigaSocio__NomeCognome-p" : "RigaSocio__NomeCognome"}>
          {option.nome} {option.cognome}
        </div>{" "}
        {!prenotazione && (
          <div className="RigaSocio__Codice">
            <Typography fontFamily="monospace" fontSize="small">
              {option.codice}
            </Typography>
          </div>
        )}{" "}
        {option.email}
      </Stack>
    </>
  );
});
